var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginBgAsset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 574,
    viewBox: "0 0 1920 574",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_5905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M959 34.0195L1918 595.02",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804 121.02L1916 777.574",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 213.02L1299 595.02",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494 304.02L989 595.02",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 395.02L679 595.02",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 35.0195L-4 596.02",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114 121.02L310 594.02",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269 213.02L620 595.02",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425 304.02L930 595.02",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1581 395.02L1086 686.02",
    stroke: "#211344",
    strokeWidth: 0.893
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37_5905)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959 395.02L1271 578.281L962 760.477L648.266 577.281L959 395.02Z",
    fill: "url(#paint0_linear_37_5905)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.256 577.28L959 395.599L1270.01 578.282L961.999 759.897L649.256 577.28Z",
    stroke: "#8960F5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_37_5905)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959 395.02L1271 578.281L962 760.477L959 395.02Z",
    fill: "#A683FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.493 759.606L959.507 395.897L1270.01 578.282L962.493 759.606Z",
    stroke: "#8960F5"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.102 577.332L961.067 760.609L1272.2 577.332L1533.72 0H377.851L649.102 577.332Z",
    fill: "url(#paint1_linear_37_5905)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M649.102 577.332L961.067 760.609L1272.2 577.332L1423.72 0H487.851L649.102 577.332Z",
    fill: "url(#paint2_linear_37_5905)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M651.102 577.332L961.067 760.609L1270.2 577.332L1323.72 0H607.851L651.102 577.332Z",
    fill: "url(#paint3_linear_37_5905)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.586 446.045L1228.9 604.234L962.176 761.502L691.365 603.37L959.586 446.045Z",
    fill: "#160C2F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M753.256 641.061L961.259 762.66L1164.89 641.061L1162.72 424.02H753.999L753.256 641.061Z",
    fill: "url(#paint4_linear_37_5905)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37_5905",
    x: 534.266,
    y: 383.02,
    width: 850.734,
    height: 593.457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 102
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 57
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0417678 0 0 0 0 0.019455 0 0 0 0 0.09755 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_5905"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_5905",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_37_5905",
    x: 845,
    y: 383.02,
    width: 540,
    height: 593.457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 102
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 57
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0417678 0 0 0 0 0.019455 0 0 0 0 0.09755 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37_5905"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37_5905",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_5905",
    x1: 648.266,
    y1: 760.477,
    x2: 1271,
    y2: 760.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865EE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6536E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_37_5905",
    x1: 480.473,
    y1: 135.059,
    x2: 480.473,
    y2: 760.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865EE8",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6536E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_37_5905",
    x1: 613.253,
    y1: 203.836,
    x2: 613.253,
    y2: 760.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865EE8",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6536E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_37_5905",
    x1: 749.947,
    y1: 301.953,
    x2: 749.947,
    y2: 760.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865EE8",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6536E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_37_5905",
    x1: 834.964,
    y1: 558.456,
    x2: 834.964,
    y2: 762.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#865EE8",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6536E2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_5905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 574,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBgAsset);
export default __webpack_public_path__ + "static/media/LoginBgAsset.257d014b1de292e2a3ac5fc0f54d61ff.svg";
export { ForwardRef as ReactComponent };